// Triggers a browser download for the given URL with the given file name.
export const downloadFile = (url: string, fileName: string) => {
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.rel = 'noopener noreferrer';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

// Triggers a browser download for the given Blob with the given file name.
export const downloadBlobAsFile = (blob: Blob, fileName: string) => {
  const url = URL.createObjectURL(blob);
  try {
    downloadFile(url, fileName);
  } finally {
    URL.revokeObjectURL(url);
  }
};
